module.exports = __webpack_public_path__ + "media/images/icon__reddit@2x-5ad858bb2e39c854c4b132104cfb01b5.png";